export default __webpack_public_path__ + "static/media/branche-pe.b43238b8.png";